import { Box, Paper, PaperProps, SxProps } from '@mui/material';
import { ReactNode } from 'react';

import { SolaForceHeading } from '~/components/SolaForceHeading';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportViewLayout/useStyles';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = {
  heading: string;
  isLoading?: boolean;
  slots?: {
    toolbar?: {
      main?: ReactNode;
      actions?: ReactNode;
    };
  };
  slotProps?: {
    content?: PaperProps;
  };
  children?: ReactNode;
};

export const ReportViewLayout = (props: PropsType) => {
  const { heading, isLoading, slots, children, slotProps } = props;

  const sxStyles = useSxStyles();

  const ConditionalContent = (ccProps: {
    content?: ReactNode;
    sx?: SxProps;
  }) => {
    const { content, sx } = ccProps;
    return !!content ? <Box sx={sx}>{content}</Box> : null;
  };

  return (
    <Box sx={sxStyles.root}>
      <SolaForceHeading
        heading={heading}
        slotProps={{ root: { sx: sxStyles.heading } }}
      />
      {!!isLoading ? (
        <LoadingView />
      ) : (
        <>
          {!!slots?.toolbar && (
            <Paper sx={sxStyles.toolbar}>
              <Box sx={sxStyles.toolbarMain}>{slots.toolbar.main}</Box>
              <Box></Box>
              <ConditionalContent
                sx={sxStyles.toolbarActions}
                content={slots.toolbar.actions}
              />
            </Paper>
          )}
          {!!children && (
            <Box sx={sxStyles.contentWrapper}>
              <Paper
                {...slotProps?.content}
                sx={mergeSxProps(sxStyles.content, slotProps?.content?.sx)}
              >
                {children}
              </Paper>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
